import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import "./VitalsCard.css";

export default function VitalsCard({
  title,
  value,
  unit,
  icon: Icon,
  status = "normal",
  trend = "stable",
}) {
  const TrendIcon =
    trend === "up" ? TrendingUp :
    trend === "down" ? TrendingDown :
    Minus;

  return (
    <div className={`vitals-card-premium ${status}`}>
      <div className="vitals-card-header">
        <span className="vitals-label">{title}</span>
        <div className={`vitals-icon-wrapper ${status}`}>
          <Icon size={20} />
        </div>
      </div>

      <div className="vitals-metrics-main">
        <div className="vitals-main-value">
          <span className="value-number">{value}</span>
          <span className="value-unit">{unit}</span>
        </div>
      </div>

      <div className="vitals-card-footer">
        <span className={`status-badge ${status}`}>
          {status.toUpperCase()}
        </span>
        <span className={`trend-indicator ${trend}`}>
          <TrendIcon size={14} />
          {trend === "stable" ? "Stable" : trend === "up" ? "Up" : "Down"}
        </span>
      </div>
    </div>
  );
}
